import { Injectable } from '@angular/core';
import { PdfService } from '../services/pdf.service';
import { MatDialog } from '@angular/material';
import { AuthService } from '../services/auth.service';
import { IStudyReportWizard } from '../services/wizard/study-report/study-report.wizard.service';
import { StudyReporDirectTypingWizard } from '../services/wizard/study-report/study-report-direct-typing.wizard';
import { StudyReportSearchItem } from '../model/study-report-search-item';
import { StudyReporDirectTypingWordWizard } from '../services/wizard/study-report/study-report-direct-typing-word.wizard';
import { StudyReportService } from '../services/study-report/study-report.service';
@Injectable()
export class StudyReportWizardFactory {
    constructor(private pdfService: PdfService
        , private dialog: MatDialog
        , private authService: AuthService
        , private studyReportService: StudyReportService) {}

    public CreateStudyReportWizard(
      studyReportSearchItem: StudyReportSearchItem,
       isReadOnly: boolean,
       setControlAdmin:boolean = false,
       isAudit:boolean = false): IStudyReportWizard {
        if (this.authService.isStudyReportCircuitWord()) {
            return new StudyReporDirectTypingWordWizard(
              studyReportSearchItem,
              this.pdfService,
              this.dialog,
              this.authService,
              this.studyReportService,
              isReadOnly,
              isAudit);
        } else {
            return new StudyReporDirectTypingWizard(
              studyReportSearchItem,
              this.pdfService,
              this.dialog,
              this.authService,
              this.studyReportService,
              isReadOnly,
              setControlAdmin,
              isAudit);
        }
    }
}
